import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { ProjectReportHeaderComponent } from './project-report-header/project.report-header.component';
import { ProjectSummaryReportComponent } from './project-summary-report/project.report.summary.component';
import { ProjectActivityReportComponent } from './project-activity-report/project.report.activity.component';
import { ProjectTeamReportComponent } from './project-team-report/project.report.team.component';
import { ProjectTrackerReportComponent } from './project-tracker-report/project.report.tracker.component';
import { ProjectDiskReportComponent } from './project-disk-report/project.report.disk.component';
import { ProjectScmReportComponent } from './project-scm-report/project.report.scm.component';
import { ProjectFrsReportComponent } from './project-frs-report/project.report.frs.component';
import { ProjectAdminChecksComponent } from '../admin/projectAdminChecks/project.admin.checks.component';

export const PROJECT_REPORTS_STATES: any[] = [
    {
        name: 'home.project.summary.reports',
        url: '/reports',
        redirectTo: 'home.project.summary.reports.summary',
        views: {
            'projectheader': {
                component: ProjectReportHeaderComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.summary',
        url: '/summary',
        views: {
            'contentarea@home.project.summary': {
                component: ProjectSummaryReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.activity',
        url: '/activity?page_num&page_size&sort_field&sort_dir&section&activityDateFrom&activityDateTo&rangeDate&userId&subprojects',
        params: {
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            },
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            },
            ignore: {
                value: 'forumthreadAccess',
                squash: true
            },
            type: {
                value: 'activity',
                squash: true
            },
            activityDateFrom: {
                value: '',
                squash: true
            },
            activityDateTo: {
                value: '',
                squash: true
            },
            rangeDate: {
                value: '-7 days',
                squash: true
            },
            userId: {
                value: '',
                squash: true
            },
            subprojects: {
                value: 'N',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectActivityReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.team',
        url: '/team?page_num&page_size&sort_field&sort_dir&startDate&endDate&rangeDate&subprojects&subproject&project&user',
        params: {
            sort_field: {
                value: 'unixName',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            },
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            },
            type: {
                value: 'team',
                squash: true
            },
            startDate: {
                value: '',
                squash: true
            },
            endDate: {
                value: '',
                squash: true
            },
            rangeDate: {
                value: '',
                squash: true
            },
            user: {
                value: '',
                squash: true
            },
            subproject: {
                value: '',
                squash: true
            },
            subprojects: {
                value: 'Y',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectTeamReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.tracker',
        url: '/tracker?assignee&submitter&participant&tracker&releases&sprint&rangeDate&sort_field&sort_dir',
        params: {
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            assignee: {
                value: '',
                squash: true
            },
            submitter: {
                value: '',
                squash: true
            },
            participant: {
                value: '',
                squash: true
            },
            tracker: {
                value: '',
                squash: true
            },
            releases: {
                value: '',
                squash: true
            },
            sprint: {
                value: '',
                squash: true
            },
            rangeDate: {
                value: '',
                squash: true
            },
            type: {
                value: 'tracker'
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectTrackerReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.disk',
        url: '/disk?rangeDate',
        params: {
            rangeDate: {
                value: '',
                squash: true
            },
            type: {
                value: 'disk'
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectDiskReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.scm',
        url: "/scm?page_num&page_size&rangeDate&subprojects&sort_dir&sort_field&details&type",
        reloadOnSearch: false,
        params: {
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            },
            sort_field: {
                value: 'commit_date',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            },
            report: {
                value: 'true',
                squash: true
            },
            subprojects: {
                value: 'N',
                squash: true
            },
            details: {
                value: 'N',
                squash: true
            },
            rangeDate: {
                value: '-7 days',
                squash: true
            },
            type: {
                value: 'scm',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectScmReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.frs',
        url: "/frs?subprojects&detail&package&dateFrom&dateTo&rangeDate&type",
        resolve: [
            {
                token: 'packages',
                deps: [HttpClient, 'project'],
                resolveFn: async (http: HttpClient, project: any) => {
                    const url = '/api/frspackage/' + _.get(project, 'unixName', '') + '/package';
                    try {
                        const response = await http.get(url).toPromise();
                        return _.get(response, 'data.items', []);
                    } catch (error) {
                        console.log(error);
                        return [];
                    }
                }
            }
        ],
        reloadOnSearch: false,
        params: {
            subprojects: {
                value: 'N',
                squash: true
            },
            detail: {
                value: 'N',
                squash: true
            },
            package: {
                type: 'int',
                value: null,
                squash: true
            },
            dateFrom: {
                value: '',
                squash: true
            },
            dateTo: {
                value: '',
                squash: true
            },
            rangeDate: {
                value: '-7 days',
                squash: true
            },
            type: {
                value: 'frs',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectFrsReportComponent
            }
        }
    },
    {
        name: 'home.project.summary.reports.checks',
        url: '/checks?id&since&before&range&page_num&sort_field&sort_dir',
        reloadOnSearch: true,
        params: {
            id: {
                type: 'int',
                value: 0,
                squash: true
            },
            since: {
                value: '',
                squash: true
            },
            before: {
                value: '',
                squash: true
            },
            range: {
                value: '',
                squash: true
            },
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 10,
                squash: true
            },
            type: {
                value: 'health'
            },
            sort_field: {
                value: 'createDate',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminChecksComponent
            }
        }
    }
];
